define(function(require) {
    var $ = require('jquery'),
        dialog = require('../../dialog/0.0.0/dialog'),
        gRequest = null;

    $.ajaxSetup({
        dataType: 'json',
        beforeSend: function(request) {
            gRequest = request;
        }
    });

    function addDeferred(func, withFail, args) {
        var dtd = $.Deferred();
        func
            .apply($, args)
            .done(function(response, statusText, jqXHR) {
                if (response.message) {
                    response.msg = response.message;
                }
                if (withFail) {
                    if (
                        response.type === 'success' ||
                        response.type === 'succ'
                    ) {
                        dtd.resolveWith(this, [response, statusText, jqXHR]);
                    } else if (
                        response.type === 'error' ||
                        response.type === 'err'
                    ) {
                        dtd.rejectWith(this, [response, statusText, jqXHR]);
                    }
                } else {
                    dtd.resolveWith(this, [response, statusText, jqXHR]);
                }
            })
            .fail(function(jqXHR, statusText, error) {
                if (error !== 'abort') {
                    dialog.alert(error);
                }
                dtd.rejectWith(this, [error, statusText, jqXHR]);
            });

        dtd.fail(function(response, statusText, jqXHR) {
            if (
                withFail &&
                typeof response === 'object' &&
                (response.type === 'error' || response.type === 'err')
            ) {
                if (response.code === 302) {
                    window.location.href = response.url;
                } else {
                    dialog.alert(response.message || response.msg);
                }
            }
            dtd.rejectWith(this, [response, statusText, jqXHR]);
        });

        dtd.request = gRequest;

        return dtd;
    }

    var ajax = {
        get: function() {
            return addDeferred($.get, false, arguments);
        },
        getWithFail: function() {
            return addDeferred($.get, true, arguments);
        },
        getJSON: function() {
            return addDeferred($.getJSON, false, arguments);
        },
        getJSONWithFail: function() {
            return addDeferred($.getJSON, true, arguments);
        },
        post: function() {
            return addDeferred($.post, false, arguments);
        },
        postWithFail: function() {
            return addDeferred($.post, true, arguments);
        },
        ajax: function() {
            return addDeferred($.ajax, false, arguments);
        },
        ajaxWithFail: function() {
            return addDeferred($.ajax, true, arguments);
        },
        pjax: function(url, container, data) {
            if ($.support.pjax) {
                container = container || '#pjax-container';
                data = data || {};
                $.pjax({ url: url, container: container, data: data });
            } else {
                this.jump(url);
            }
        },
        jump: function(url) {
            window.location.href = url;
        },
        newPage: function(url) {
            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
        }
    };

    window.ajax = ajax;

    return ajax;
});



// WEBPACK FOOTER //
// ./modules/ajax/0.0.0/ajax.js